export default "__VITE_ASSET__BT9vSp62__"